<div class="modal-header">
  <h5 class="modal-title">
    <span class="modal-title-icon is-chat" aria-hidden="true"></span>
    Chat
  </h5>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body chat-modal-body" [class.has-selected-room]="!!selectedRoom()">
  <app-chat-room-list class="chat-modal-rooms" [selectedRoomId]="selectedRoom()?.IdChat ?? null" (roomSelected)="onRoomSelected($event)" />
  <app-chat-conversation class="chat-modal-conversation" [room]="selectedRoom()" (roomLeft)="onRoomLeft()" (back)="onBack()" />
</div>
